import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

function publicClient() {
  return createClient<Database>(
    process.env.SUPABASE_URL!,
    process.env.SUPABASE_PUBLISHABLE_KEY!,
    { auth: { storage: undefined, persistSession: false, autoRefreshToken: false } },
  );
}

export type PublicTestimonial = {
  id: string;
  quote: string;
  author_name: string;
  author_role: string | null;
  rating: number;
  avatar_url: string | null;
  source: string;
};

export type PublicStat = {
  id: string;
  emoji: string | null;
  label: string;
  value: string;
};

export const getPublishedTestimonials = createServerFn({ method: "GET" }).handler(
  async (): Promise<PublicTestimonial[]> => {
    const supabase = publicClient();
    const { data, error } = await supabase
      .from("testimonials")
      .select("id, quote, author_name, author_role, rating, avatar_url, source")
      .eq("is_published", true)
      .order("is_featured", { ascending: false })
      .order("sort_order", { ascending: true })
      .order("created_at", { ascending: false })
      .limit(50);
    if (error) {
      console.error("[testimonials] read failed", error);
      return [];
    }
    return data ?? [];
  },
);

export const getPublishedStats = createServerFn({ method: "GET" }).handler(
  async (): Promise<PublicStat[]> => {
    const supabase = publicClient();
    const { data, error } = await supabase
      .from("homepage_stats")
      .select("id, emoji, label, value")
      .eq("is_published", true)
      .order("sort_order", { ascending: true })
      .limit(24);
    if (error) {
      console.error("[homepage_stats] read failed", error);
      return [];
    }
    return data ?? [];
  },
);
